import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgMute = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10.165 2.521c1.122-1.155 2.934-.263 2.934 1.44V20.04c0 1.744-1.885 2.617-2.987 1.384l-3.587-4.015-.002-.002a.27.27 0 0 0-.2-.091H3.75q-.03 0-.057-.003C2.752 17.28 2 16.416 2 15.356V8.293c0-1.08.783-1.956 1.749-1.956h2.598c.072 0 .142-.031.193-.084zM3.792 15.676h2.532c.462 0 .909.206 1.237.575l3.587 4.013c.18.202.486.059.486-.225V3.961c0-.279-.296-.422-.477-.235L7.532 7.457a1.65 1.65 0 0 1-1.185.517H3.75c-.157 0-.285.143-.285.318v7.065c0 .175.128.318.285.318z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M14.628 9.28a.743.743 0 0 1 0-1.06.766.766 0 0 1 1.074 0l2.5 2.47 2.501-2.47a.766.766 0 0 1 1.075 0 .743.743 0 0 1 0 1.06l-2.501 2.47 2.5 2.47a.743.743 0 0 1 0 1.06.766.766 0 0 1-1.074 0l-2.5-2.47-2.501 2.47a.766.766 0 0 1-1.075 0 .743.743 0 0 1 0-1.06l2.501-2.47z"
      />
    </svg>
  );
};
export default SvgMute;
